

import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CaptureEmailFormComponent } from './capture-email-form.component';

@NgModule({
  declarations: [CaptureEmailFormComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  entryComponents: [CaptureEmailFormComponent],
  exports: [
    CaptureEmailFormComponent
  ]
})
export class CaptureEmailFormModule {}
